import {Component, OnInit} from '@angular/core';
import {DataRow} from '../../../DoraData/data-row';
import {DataTupla} from '../../../DoraData/data-tupla';
import {DoraDataGridSelectorComponent} from '../dora-data-grid-selector.component';

@Component({
  selector: 'dora-data-grid-selector-tab',
  templateUrl: './dora-data-grid-selector-tab.component.html',
  styleUrls: ['./dora-data-grid-selector-tab.component.scss']
})
export class DoraDataGridSelectorTabComponent extends DoraDataGridSelectorComponent {


  public onSelect(rowIndex: number, dataRow: DataRow): void {
    this.selectedGrid(dataRow.Id);
  }

  // Methods for Css Class
  public getElementContainerCssClass(rowIndex: number, dataRow: DataRow): string {
    let result: string;

    result = 'tab-element-container ' + dataRow.CssFormat;
    result += (dataRow.selected) ? ' on' : ' off';

    return result;
  }
  public getElementContentCssClass(rowIndex: number, dataRow: DataRow): string {
    return 'tab-element-content';
  }

  public getElementContent(rowIndex: number, dataRow: DataRow): string {
    let result = '';
    const descriptionTupla: DataTupla = dataRow.getDataTupla('Description');
    if (descriptionTupla !== undefined) {
      result = descriptionTupla.Value;
    }
    return result;
  }

}
